import useRequest, {
    RequestKeys,
    RequestFn,
} from 'app/hooks/useRequest'

import config from 'app/requests/FxRate.requests'
import FxRate from '../FxRate.types'

export default (
    id: number | string,
) => {
    return useRequest<FxRate>({
        key: RequestKeys.getFxRateById,
        params: {
            id,
        },
        requestFunc: RequestFn.getEntity(config.get),
        enabled: Boolean(id),
        keepPreviousData: true,
    })
}
